/**
 * En este archivo se encuentran las estructuras necesarias para manejar el state de implemento seleccionado
 * cuando se da click a "Mas detalles"
 */

export enum TipoAccionDetalle {
  CHANGE_NOMBRE = 'CHANGE_NOMBRE',
  CHANGE_CORREO = 'CHANGE_CORREO',
  CHANGE_ESTATURA = 'CHANGE_ESTATURA',
  CHANGE_EDAD = 'CHANGE_EDAD',
  CHANGE_PESO = 'CHANGE_PESO',
  CHANGE_PORCENTAJEGRASA = 'CHANGE_PORCENTAJEGRASA',
  CHANGE_TIPOACTIVIDAD = 'CHANGE_TIPOACTIVIDAD',
  CHANGE_OBJETIVO = 'CHANGE_OBJETIVO',
  CHANGE_RESPONDIO = 'CHANGE_RESPONDIO',
  CHANGE_SEDEID = 'CHANGE_SEDEID',
  CHANGE_UNIDADPESO = 'CHANGE_UNIDADPESO',
  CHANGE_UNIDADESTATURA = 'CHANGE_UNIDADESTATURA',
  CHANGE_SEXO = 'CHANGE_SEXO',
  CHANGE_SUPLEMENTOS = 'CHANGE_SUPLEMENTOS',
  CHANGE_NFORM = 'CHANGE_NFORM',
  CHANGE_CANTIDADCOMIDAS = 'CHANGE_CANTIDADCOMIDAS',
  CHANGE_RESET = 'RESET',
  CHANGE_PROTEINAS = 'CHANGE_PROTEINAS',
  CHANGE_CARBOHIDRATOS = 'CHANGE_CARBOHIDRATOS',
  CHANGE_GRASAS = 'CHANGE_GRASAS',
  CHANGE_VALESTATURA = 'CHANGE_VALESTATURA',
  CHANGE_VALPESO = 'CHANGE_VALPESO',
  CHANGE_VALTACTIVIDAD = 'CHANGE_VALTACTIVIDAD',
  CHANGE_VALOBJETIVO = 'CHANGE_VALOBJETIVO',
  CHANGE_VALPGRASA = 'CHANGE_VALPGRASA',
  CHANGE_VALNOMBRE = 'CHANGE_VALNOMBRE',
  CHANGE_VALCORREO = 'CHANGE_VALCORREO',
  CHANGE_VALCAPTCHA = 'CHANGE_VALCAPTCHA',
  CHANGE_PULGADA = 'CHANGE_PULGADA',
  CHANGE_VECESPORSEMANA = 'CHANGE_VECESPORSEMANA',
  CHANGE_PDFALIMENTO = 'CHANGE_PDFALIMENTO',
  CHANGE_PDFCARDIO = 'CHANGE_PDFCARDIO',
  CHANGE_PDFENTRENAMIENTO = 'CHANGE_PDFENTRENAMIENTO',
  CHANGE_DONDEENTRENAS = 'CHANGE_DONDEENTRENAS',
  CHANGE_DIASPRIORIDAD = 'CHANGE_DIASPRIORIDAD',
  CHANGE_USUARIOTESTASESORIAID = 'CHANGE_USUARIOTESTASESORIAID',
  CHANGE_TIEMPORUTINADIARIA = 'CHANGE_TIEMPORUTINADIARIA',
  CHANGE_FOTOS = 'CHANGE_FOTOS',
}
function subtractYears(date: Date, years: number) {
  date.setFullYear(date.getFullYear() - years);
  return date;
}

export interface AccionDetalle {
  type: TipoAccionDetalle;
  payload: string | number | boolean | string[];
}

export interface IInitialState {
  nombre: string;
  correo: string;
  estatura: string | number;
  pulgadas: string;
  pdfAlimento: string;
  pdfCardio: string;
  pdfEntrenamiento: string;
  edad: string;
  peso: number;
  sedeID: number;
  porcentajeGrasa: number;
  tipoActividad: string;
  objetivo: string;
  unidadPeso: string;
  unidadEstatura: string;
  sexo: boolean;
  nForm: number;
  proteinas: number;
  carbohidratos: number;
  grasas: number;
  respondio: boolean;
  valEstatura: boolean;
  valPeso: boolean;
  valTActividad: boolean;
  valObjetivo: boolean;
  valPGrasa: boolean;
  valNombre: boolean;
  valCorreo: boolean;
  valCaptcha: boolean;
  valUPeso: boolean;
  suplementos: string;
  vecesPorSemana: number;
  dondeEntrenas: number;
  diasPrioridad: number;
  cantidadComidas: number;
  usuarioTestAsesoriaID: number;
  tiempoRutinaDiaria: string;
  fotos: string[];
}

export const initialState: IInitialState = {
  nombre: '',
  correo: '',
  estatura: '0',
  edad: subtractYears(new Date(), 18).toString(),
  peso: 0,
  pdfAlimento: '',
  pdfCardio: '',
  pdfEntrenamiento: '',
  porcentajeGrasa: 0,
  tipoActividad: '',
  pulgadas: '0',
  objetivo: '',
  unidadPeso: '',
  unidadEstatura: '',
  sexo: true,
  respondio: false,
  nForm: 0,
  sedeID: 10,
  proteinas: 0,
  carbohidratos: 0,
  diasPrioridad: 0,
  grasas: 0,
  valEstatura: false,
  valPeso: false,
  valTActividad: false,
  valObjetivo: false,
  valPGrasa: false,
  valNombre: false,
  valCorreo: false,
  valCaptcha: false,
  valUPeso: false,
  suplementos: '',
  vecesPorSemana: 0,
  dondeEntrenas: 0,
  cantidadComidas: 0,
  usuarioTestAsesoriaID: 0,
  tiempoRutinaDiaria: '',
  fotos: [],
};

export const detalleReducer = (state: IInitialState, action: AccionDetalle) => {
  const { type, payload } = action;
  switch (type) {
    case TipoAccionDetalle.CHANGE_NOMBRE:
      return {
        ...state,
        nombre: String(payload),
      };
    case TipoAccionDetalle.CHANGE_PDFALIMENTO:
      return {
        ...state,
        pdfAlimento: String(payload),
      };
    case TipoAccionDetalle.CHANGE_PDFCARDIO:
      return {
        ...state,
        pdfCardio: String(payload),
      };
    case TipoAccionDetalle.CHANGE_PDFENTRENAMIENTO:
      return {
        ...state,
        pdfEntrenamiento: String(payload),
      };
    case TipoAccionDetalle.CHANGE_CORREO:
      return {
        ...state,
        correo: String(payload),
      };
    case TipoAccionDetalle.CHANGE_ESTATURA:
      return {
        ...state,
        estatura: String(payload),
      };
    case TipoAccionDetalle.CHANGE_PULGADA:
      return {
        ...state,
        pulgadas: String(payload),
      };
    case TipoAccionDetalle.CHANGE_EDAD:
      return {
        ...state,
        edad: String(payload),
      };
    case TipoAccionDetalle.CHANGE_PESO:
      return {
        ...state,
        peso: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_CANTIDADCOMIDAS:
      return {
        ...state,
        cantidadComidas: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_PORCENTAJEGRASA:
      return {
        ...state,
        porcentajeGrasa: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_TIPOACTIVIDAD:
      return {
        ...state,
        tipoActividad: String(payload),
      };
    case TipoAccionDetalle.CHANGE_OBJETIVO:
      return {
        ...state,
        objetivo: String(payload),
      };
    case TipoAccionDetalle.CHANGE_UNIDADPESO:
      return {
        ...state,
        unidadPeso: String(payload),
      };
    case TipoAccionDetalle.CHANGE_UNIDADESTATURA:
      return {
        ...state,
        unidadEstatura: String(payload),
      };
    case TipoAccionDetalle.CHANGE_SEXO:
      return {
        ...state,
        sexo: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_NFORM:
      return {
        ...state,
        nForm: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_DIASPRIORIDAD:
      return {
        ...state,
        diasPrioridad: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_CARBOHIDRATOS:
      return {
        ...state,
        carbohidratos: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_PROTEINAS:
      return {
        ...state,
        proteinas: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_SEDEID:
      return {
        ...state,
        sedeID: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_GRASAS:
      return {
        ...state,
        grasas: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_VALESTATURA:
      return {
        ...state,
        valEstatura: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VALPESO:
      return {
        ...state,
        valPeso: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_SUPLEMENTOS:
      return {
        ...state,
        suplementos: String(payload),
      };
    case TipoAccionDetalle.CHANGE_RESPONDIO:
      return {
        ...state,
        respondio: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VALTACTIVIDAD:
      return {
        ...state,
        valTActividad: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VALOBJETIVO:
      return {
        ...state,
        valObjetivo: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VALPGRASA:
      return {
        ...state,
        valPGrasa: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VALNOMBRE:
      return {
        ...state,
        valNombre: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VALCORREO:
      return {
        ...state,
        valCorreo: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VALCAPTCHA:
      return {
        ...state,
        valCaptcha: Boolean(payload),
      };
    case TipoAccionDetalle.CHANGE_VECESPORSEMANA:
      return {
        ...state,
        vecesPorSemana: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_DONDEENTRENAS:
      return {
        ...state,
        dondeEntrenas: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_USUARIOTESTASESORIAID:
      return {
        ...state,
        usuarioTestAsesoriaID: Number(payload),
      };
    case TipoAccionDetalle.CHANGE_TIEMPORUTINADIARIA:
      return {
        ...state,
        tiempoRutinaDiaria: String(payload),
      };
    case TipoAccionDetalle.CHANGE_FOTOS:
      return {
        ...state,
        fotos: payload as string[],
      };
    case TipoAccionDetalle.CHANGE_RESET:
      return initialState;
  }
};
